module.exports = __webpack_public_path__ + "videos/schuette-welcome-video-2.b28d166.mp4";